// Maps calculationTypeId (from ConsultationQuestionValueTypes enum) to i18n translation key
const calculationDescriptions = {
  // Contour amplitude analysis (mV)
  7000: 'calculationDesc.ecgContourPmv',
  7010: 'calculationDesc.ecgContourQmv',
  7020: 'calculationDesc.ecgContourRmv',
  7030: 'calculationDesc.ecgContourSmv',
  7040: 'calculationDesc.ecgContourTmv',
  7050: 'calculationDesc.ecgContourSTmv',
  7060: 'calculationDesc.ecgContourDTpercent',

  // Contour interval analysis (ms)
  7070: 'calculationDesc.ecgContourPms',
  7080: 'calculationDesc.ecgContourPQms',
  7090: 'calculationDesc.ecgContourPRms',
  7100: 'calculationDesc.ecgContourDPRms',
  7110: 'calculationDesc.ecgContourQRSms',
  7120: 'calculationDesc.ecgContourDQRSms',
  7130: 'calculationDesc.ecgContourQTms',

  // QRS Speed analysis - front (ascending)
  8000: 'calculationDesc.ecgSpeedQRSFrontV',
  8010: 'calculationDesc.ecgSpeedQRSFrontS',
  8020: 'calculationDesc.ecgSpeedQRSFrontAvrS',
  8030: 'calculationDesc.ecgSpeedQRSFrontSV',

  // QRS Speed analysis - back (descending)
  8040: 'calculationDesc.ecgSpeedQRSBackV',
  8050: 'calculationDesc.ecgSpeedQRSBackS',
  8060: 'calculationDesc.ecgSpeedQRSBackAvrS',
  8070: 'calculationDesc.ecgSpeedQRSBackSV',

  // QRS Speed analysis - combined
  8080: 'calculationDesc.ecgSpeedQRSDAvrS',
};

export default calculationDescriptions;
